import { render, staticRenderFns } from "./SellersUpdate.vue?vue&type=template&id=fb6d9c5a"
import script from "./SellersUpdate.vue?vue&type=script&lang=js"
export * from "./SellersUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports